module.exports = __webpack_public_path__ + "img/about-glories2.25fb010.png";